<script>
  import { Modal } from 'bootstrap';
  import { getContext, onMount } from 'svelte';
  import FormTextarea from './FormControls/FormTextarea.svelte';
  import Loader from '../components/Loader.svelte';
  export let handleClick = (e) => {};
  let bulkChangeRiskRank;
  let isLoading = false;
  onMount(() => {
    bulkChangeRiskRank = new Modal(document.getElementById('bulkChangeRiskRank'), {
      keyboard: false,
    });
  });
  import * as yup from 'yup';
  export let success = () => {};
  export const show = (data) => {
    isLoading = false;
    $form = data;
    $form.riskRankUpdateReason = '';
    bulkChangeRiskRank.show();
  };
  export const showModal = () => {
    bulkChangeRiskRank.show();
  };
  const showDialog = getContext('showDialog');
  let defaultValue = {
    tasks: [],
  };
  import { createForm } from 'svelte-forms-lib';
  import { client } from 'root/api/index.js';
  import { configItem, getValueBySearchValue } from './Helper';
  import DropDown from './DropDown.svelte';
  const { form, errors, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      riskRank: yup.string().required('Please select risk rank'),
    }),
    onSubmit: (values) => {
      client
        .taskRiskRank(values)
        .then(() => {
          bulkChangeRiskRank.hide();
          success();
        })
        .catch((error) => {
          showDialog({
            message: `${error}`,
            okFunc: () => {
              isLoading = false;
              showModal();
            },
          });
          bulkChangeRiskRank.hide();
        });
    },
  });
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="bulkChangeRiskRank"
  tabindex="-1"
  aria-labelledby="bulkChangeRiskRankLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    {#if isLoading}
      <div class="modal-content p-5 text-center">
        <div class="p-5">
          <Loader Style="loader-block" />
        </div>
      </div>
    {:else}
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title font-size-14"
            id="exampleModalLabel"
          >
            Change Risk Rank
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div
              class="form-group position-relative priority-dropdown-modal {$errors.riskRank
                ? 'error'
                : ''}"
            >
              <label
                for=""
                class="mb-3 color-lead">{$form?.tasks?.length || 0} Tasks selected</label
              >
              <div class="form-group mb-3">
                <label
                  for=""
                  class="form-label">Select Risk Rank</label
                >
                <DropDown
                  dropdownId="bulkRiskRank"
                  showIcon={false}
                  checkbox={false}
                  deleteSelected={false}
                  active={true}
                  titleChanged={true}
                  title={getValueBySearchValue(
                    configItem.riskRank,
                    'id',
                    $form.riskRank,
                    'name',
                    'Risk Rank',
                  )}
                  on:onSelect={(item) => {
                    $form.riskRank = item.detail.id;
                  }}
                  option={configItem.riskRank}
                  Style="select-block priority-dropdown"
                />
                {#if $errors.riskRank}
                  <label
                    class="formError"
                    style="top: 8px;bottom: auto;"
                    for="reason">{$errors.riskRank}</label
                  >
                {/if}
              </div>
            </div>
          </div>
          <div class="form-group">
            <FormTextarea
              label="Please tell us why you are making this change?"
              placeholder="Enter Notes (Optional)"
              name="riskRankUpdateReason"
              bind:value={$form.riskRankUpdateReason}
              maxLength={configItem.maxLength.description}
              rows="6"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
            data-bs-dismiss="modal">Cancel</button
          >
          <button
            type="button"
            class="btn btn-primary m-0 px-4 font-size-12"
            on:click={() => {
              isLoading = true;
              handleSubmit();
            }}>Done</button
          >
        </div>
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  .active,
  .active:hover {
    background-color: $blue-color;
    color: $white-color;
    border: 1px solid $blue-color;
  }
</style>
